var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.50466 12.197C6.62158 12.197 6.73851 12.1539 6.83081 12.0616C7.00928 11.8831 7.00928 11.5878 6.83081 11.4093L3.42158 8.00007L6.83081 4.59084C7.00928 4.41238 7.00928 4.117 6.83081 3.93853C6.65235 3.76007 6.35697 3.76007 6.17851 3.93853L2.44312 7.67392C2.26466 7.85238 2.26466 8.14776 2.44312 8.32623L6.17851 12.0616C6.27081 12.1539 6.38774 12.197 6.50466 12.197Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.87386 8.46214H13.2308C13.4831 8.46214 13.6923 8.25291 13.6923 8.0006C13.6923 7.74829 13.4831 7.53906 13.2308 7.53906H2.87386C2.62155 7.53906 2.41232 7.74829 2.41232 8.0006C2.41232 8.25291 2.62155 8.46214 2.87386 8.46214Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.b277606867dc2ac4d49cee601ba48959.svg";
export { ForwardRef as ReactComponent };